import { writable } from "svelte/store";

export type CameraLayoutMode = "automatic" | "grid" | "focus" | "hidden";

const STORAGE_KEY = "mercadologica-camera-layout";
const validModes: CameraLayoutMode[] = ["automatic", "grid", "focus", "hidden"];

function getInitialMode(): CameraLayoutMode {
    if (typeof localStorage === "undefined") {
        return "automatic";
    }

    const savedMode = localStorage.getItem(STORAGE_KEY);
    return validModes.includes(savedMode as CameraLayoutMode)
        ? (savedMode as CameraLayoutMode)
        : "automatic";
}

function createCameraLayoutStore() {
    const { subscribe, set } = writable<CameraLayoutMode>(getInitialMode());

    return {
        subscribe,
        set(mode: CameraLayoutMode) {
            if (typeof localStorage !== "undefined") {
                localStorage.setItem(STORAGE_KEY, mode);
            }
            set(mode);
        },
    };
}

export const cameraLayoutStore = createCameraLayoutStore();

export function getNextCameraLayout(mode: CameraLayoutMode): CameraLayoutMode {
    const index = validModes.indexOf(mode);
    return validModes[(index + 1) % validModes.length];
}

export function getCameraLayoutLabel(mode: CameraLayoutMode): string {
    switch (mode) {
        case "automatic":
            return "Layout automático";
        case "grid":
            return "Layout em grade";
        case "focus":
            return "Layout com destaque";
        case "hidden":
            return "Câmeras ocultas";
    }
}
